import axios from "axios";
import axiosInstance from './index';

export const getQuotationRoomPrices = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      `/quotation/room-pricing`,
      data
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const createQuotation = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      `/quotation`,
      data
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const regenerateQuotation = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      `/quotation/regenerate`,
      data
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getQuotaionDetailById = async (id:string) => {
  try {
    const response = await axiosInstance.get(
      `/quotation/${id}/details`);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error;
      } else {
        console.error("Unknown error occurred:", error);
      }
    }
};
  
export const getPublicQuotationDetails = async (quotationId: string) => {
  try {
    const response = await axiosInstance.get(
      `/public/quotation/${quotationId}`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};
  
export const getUpdatedQuotationPrice = async (quotationId: string) => {
  try {
    const response = await axiosInstance.get(
      `/public/quotation/price/${quotationId}`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const acceptRejectUpdatedPrice = async (quotationId: string, status: string) => { 
  try {
    const response = await axiosInstance.put(
      `/public/quotation/${quotationId}/${status}`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
}

export const applyQuotationCouponCode = async (data: { quotationId: string, coupon_code: string, partial_payment: boolean }) => { 
  try {
    const response = await axiosInstance.post(
      `/public/apply-coupon`,
      data
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
}

export const removeQuotationCouponCode = async (quotationId: string) => { 
  try {
    const response = await axiosInstance.get(
      `/public/remove-coupon/${quotationId}`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
}

export const getDashboardTabsData = async (tabName: string, searchText: string, currentPage: number) => {
  try {
    const params = new URLSearchParams({
      page: `${currentPage}`, limit: '15',
      ...(!!searchText && { search: searchText }),
    });
    const response = await axiosInstance.get(`/${tabName}/staff`, { params });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getAllBookingsTabsData = async (tabName: string, searchText: string, currentPage: number) => {
  try {
    const params = new URLSearchParams({
      page: `${currentPage}`, limit: '15',
      ...(!!searchText && { search: searchText }),
      ...(!!tabName && { status: tabName }),
    });
    const response = await axiosInstance.get('/booking/list', { params });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getBookingInfo = async (bookingId: string) => {
  try {
    const response = await axiosInstance.get(`/booking/detail?id=${bookingId}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getAvailableDecks = async (itineraryId: string, roomCategoryId: string, guestCount: number,preferenceArr?:string[]) => {
  try {
    const response = await axiosInstance.get(
      !preferenceArr?.length ?  `/quotation/decks?itinerary_id=${itineraryId}&category_id=${roomCategoryId}&guest=${guestCount}`:
      `/quotation/decks?itinerary_id=${itineraryId}&category_id=${roomCategoryId}&guest=${guestCount}&prefrence=${preferenceArr?.join(",")}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getAvailableDeckRooms = async (itineraryId: string, roomCategoryId: string, guestCount: number, deckNumber: number,preferenceArr?:string[]) => {
  try {
    const response = await axiosInstance.get(
      !preferenceArr?.length ? `/quotation/available-rooms?itinerary_id=${itineraryId}&category_id=${roomCategoryId}&guest=${guestCount}&deck_no=${deckNumber}` :
       `/quotation/available-rooms?itinerary_id=${itineraryId}&category_id=${roomCategoryId}&guest=${guestCount}&deck_no=${deckNumber}&prefrence=${preferenceArr?.join(",")}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const raiseDiscountRequest = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      `/quotation/request-discount`,
      data
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const raiseSpecialServiceRequest = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      `/quotation/special-request`,
      data
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getSSRByStaff = async () => {
  try {
    const response = await axiosInstance.get(
      `/pending-task/special-request`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};


export const getDiscountRequestByStaff = async () => {
  try {
    const response = await axiosInstance.get(
      `/pending-task/quotation-discount`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const approveRejectDiscountRequest = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      `/pending-task/quotation-discount`,
      data
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const approveRejectSSRRequest = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      `/pending-task/special-request`,
      data
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};
